import { validation } from "formUtils/validation";
import * as Yup from "yup";
import { getTaxableYear } from "utils/dates";
import i18n from "i18next";

export const paiMemberShape = {
  id: validation.stringRequired,
  name: validation.stringRequired,
  expectedIncome: validation.numberRequired,
  adjustmentsIncome: validation.numberRequired,
  projectedAnnualIncome: validation.numberRequired,
};

const year = getTaxableYear()

export const validationSchema = Yup.object().shape({
  paiMembers: Yup.array().of(Yup.object().shape(paiMemberShape)),
  isSameTotalIncome: validation.stringNotRequired,
});

export const totalIncomeOptions = [
  {
    label: i18n.t("pai_option_label_yes", {year}),
    value: "true",
  },
  {
    label: i18n.t("pai_option_label_no", {year}),
    value: "false"
  },
]

